import { useEffect, useState } from 'react';
import { ANIMATION_REGISTRY } from '@/config/animationRegistry';

const { enterMs, exitMs, backdropEnter, backdropExit, panelEnter, panelExit } =
  ANIMATION_REGISTRY.modal;

export interface ModalMotionState {
  render: boolean;
  exiting: boolean;
  backdropClass: string;
  panelClass: string;
}

/**
 * Keeps modal mounted through exit animation; class names from animationRegistry.
 * Enter classes clear after enterMs so glass blur can rest idle — animating
 * backdrop-filter + scale on large panels is what made Withdraw feel janky.
 */
export function useModalMotion(open: boolean): ModalMotionState {
  const [render, setRender] = useState(open);
  const [exiting, setExiting] = useState(false);
  const [entering, setEntering] = useState(open);

  useEffect(() => {
    if (open) {
      setRender(true);
      setExiting(false);
      setEntering(true);
      const t = window.setTimeout(() => setEntering(false), enterMs);
      return () => window.clearTimeout(t);
    }
    if (!render) return;
    setEntering(false);
    setExiting(true);
    const t = window.setTimeout(() => {
      setRender(false);
      setExiting(false);
    }, exitMs);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return {
    render,
    exiting,
    backdropClass: exiting ? backdropExit : entering ? backdropEnter : '',
    panelClass: exiting ? panelExit : entering ? panelEnter : '',
  };
}
